import store from '../../store'
import TokenService from '@/services/token.service'
import { getCachedSettings } from '../../utils/helpers';

export default async (to, from, next) => {
	if (!store.getters['auth/isAuthenticated']) {
		const {
			token = '',
		} = to.query;

		TokenService.saveAccessToken(token)

		await store.dispatch('auth/getProfile')
		getCachedSettings(store)
	}

	return next('/')
}
